import { motion } from "framer-motion";
import { Quote as QuoteIcon, Star } from "lucide-react";

const items = [
  {
    quote: "The best interior detail I've had, hands down. My truck looks and smells brand new — I keep opening the door just to see it.",
    author: "Wyatt R.",
    role: "F-150 Owner · Bozeman",
  },
  {
    quote: "They treated my living room upholstery like it was a Ferrari. Absolute craftsmen. Worth every penny.",
    author: "Amelia K.",
    role: "Homeowner · Big Sky",
  },
  {
    quote: "On time, obsessive attention to detail, and my leather seats haven't looked this good since the day I bought the car.",
    author: "Marcus D.",
    role: "Audi RS5 · Belgrade",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-24 lg:py-32 max-w-[1400px] mx-auto px-6 lg:px-10" data-testid="testimonials-section">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-primary mb-4">Reviews</p>
          <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-none text-foreground">
            What our<br /><span className="italic text-primary">clients say.</span>
          </h2>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex gap-1">
            {[0,1,2,3,4].map((i) => <Star key={i} className="w-4 h-4 fill-primary text-primary" />)}
          </div>
          <span className="text-muted-foreground font-light text-sm">Loved across the Gallatin Valley</span>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
        {items.map((t, i) => (
          <motion.blockquote
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.12 }}
            className="relative p-8 lg:p-10 bg-card border border-border clip-frame flex flex-col"
            data-testid={`testimonial-${i}`}
          >
            <QuoteIcon className="w-7 h-7 text-primary/40 mb-6" />
            <p className="font-serif text-xl lg:text-2xl leading-relaxed text-foreground/90 mb-8 italic">
              &ldquo;{t.quote}&rdquo;
            </p>
            <div className="mt-auto pt-6 border-t border-border">
              <div className="text-foreground text-sm tracking-wide">{t.author}</div>
              <div className="text-muted-foreground text-xs tracking-widest uppercase mt-1">{t.role}</div>
            </div>
          </motion.blockquote>
        ))}
      </div>
    </section>
  );
}
